import { FaUser, FaBuilding, FaBook, FaClipboardList } from "react-icons/fa";
import { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Tooltip,
  LineChart,
  Line,
} from "recharts";
import KpiCard from "./KpiCard";
import ChartCard from "./ChartCard";
import MiniStatCard from "./MiniStatCard";
import BookingCard from "./BookingCard";
import CustomTooltip from "./CustomTooltip";
import VisitorOverview from "./VisitorOverview";
import "./style.css"; 
import { getBookingData, getDashboardData, getHostelAndCourseData, getVisitorData } from "../../../services/DashboardApiService/DashboardApiService";

export default function NewDashboard() {
  const [dashboardData, setDashboardData] = useState(null);
  const [dashboardLoading, setDashboardLoading] = useState(true);
  const [visitorLoading, setVisitorLoading] = useState(true);
  const [visitorData, setVisitorData] = useState([]);
  const [filter, setFilter] = useState("week");
  const [venueData, setVenueData] = useState([]);
  const [venueLoading, setVenueLoading] = useState(true);
  const [hostelAndCourse, setHostelAndCourse] = useState([]);
  const [hostelAndCourseLoading, setHostelAndCourseLoading] = useState(true);

  useEffect(() => {
    const getData = async () => {
      setDashboardLoading(true);
      setVisitorLoading(true);
      setVenueLoading(true);
      setHostelAndCourse(true);

      try {
        const [dashboardRes, visitorRes, venueRes, HostelAndCourseRes] =
          await Promise.all([
            getDashboardData(),
            getVisitorData(filter),
            getBookingData(),
            // getHostelAndCourseData(),
          ]);

        setDashboardData(dashboardRes);
        setVisitorData(visitorRes?.data?.data || []);
        setVenueData(venueRes?.data);
        setHostelAndCourse(HostelAndCourseRes?.data);
      } catch (err) {
        console.error(err);
      } finally {
        setDashboardLoading(false);
        setVisitorLoading(false);
        setVenueLoading(false);
        setHostelAndCourseLoading(false);
      }
    };

    getData();
  }, [filter]);

  const registration = dashboardData?.data?.data?.registrationData;
  const pendingRegistration  = dashboardData?.data?.data?.registrationPending?.pandingRegistration
  const totalInstitutionCount =
    Number(registration?.institution || 0) 
    // Number(registration?.academy || 0) +
    // Number(registration?.club || 0);
  const tooltipMap = {
    week: "Last 7 days",
    month: "This year (monthly data)",
    year: "All time overview",
  };

  return (
    <section className="container">
      {/* HEADER */}
      <div className="mb-4">
        <h4 className="fw-bold">Dashboard</h4>
      </div>

      {/* MIXED CARDS */}
      <div className="row g-4 align-items-stretch">
        <div className="col-lg-4 d-flex">
          <div className="w-100 d-flex flex-column gap-4">
            <KpiCard
              icon={<FaClipboardList />}
              title="Total Registration"
              value={registration?.totalRegistration || 0}
              loading={dashboardLoading}
            />

            <KpiCard
              icon={<FaBook />}
              title="Pending Registration"
              value={pendingRegistration || 0}
            />
          </div>
        </div>

        {/* PIE */}
        <div className="col-lg-4 d-flex">
          {venueLoading ? (
            <p>Loading chart...</p>
          ) : (
            <div className="card-box h-100 w-100 d-flex flex-column justify-content-evenly mx-3">
              <div className="d-flex align-items-center gap-2 border-bottom">
                <h6 className="fs-4 fw-bold mb-0">Total Venue :</h6>
                <p className="fs-4 fw-bold mb-0">{venueData?.data?.totalVenue}</p>
              </div>
              {/* CARD 1 */}
              <MiniStatCard
                title="Total Slot Booking"
                value={venueData?.data?.slotBooking?.totalSlotBooking || 0}
                amount={venueData?.data?.slotBooking?.totalSlotBookingAmount || 0}
              />

              <MiniStatCard
                title="Today Slot Booking"
                value={venueData?.data?.slotBooking?.todaySlotBooking || 0}
                amount={venueData?.data?.slotBooking?.todaySlotBookingAmount || 0}
              />
            </div>
          )}
        </div>

        <div className="col-lg-4 d-flex">
          <div className="w-100 d-flex flex-column gap-4">
            <KpiCard
              icon={<FaUser />}
              title="Individual"
              value={registration?.individual || 0}
            />
            <KpiCard
              icon={<FaBuilding />}
              title="Institution"
              value={totalInstitutionCount}
            />
          </div>
        </div>

        {/* LINE */}
        <ChartCard title="Total Registration" badge="Weekly">
          <ResponsiveContainer width="100%" height={160}>
            <LineChart data={dashboardData?.data?.data?.weeklyRegistrationData || []}>
              <XAxis dataKey="name" />
              <YAxis allowDecimals={false} />
              <Tooltip />
              <Line dataKey="value" stroke="#8757e8" />
            </LineChart>
          </ResponsiveContainer>
        </ChartCard>
      </div>

      {/* NEW ROW */}
      <div className="row g-4 mt-2 align-items-stretch">
        {/* <div className="col-lg-6 d-flex">
          <div className="card-box w-100 h-100 p-3">
           
            <div className="d-flex flex-column gap-2">
              <BookingCard
                title="Total Ticket Booking"
                badge="All Time"
                value={venueData?.data?.ticketBooking?.totalTicketBooking || 0}
                amount={venueData?.data?.ticketBooking?.totalTicketBookingAmount || 0}
              />

              <BookingCard
                title="Today Ticket Booking"
                badge="Today"
                value={venueData?.data?.ticketBooking?.todayTicketBooking || 0}
                amount={venueData?.data?.ticketBooking?.todayTicketBookingAmount || 0}
                isToday
              />
            </div>
          </div>
        </div> */}

        {/* <div className="col-lg-6 d-flex">
          <div className="kpi-card w-100 h-100 p-3">
            {hostelAndCourseLoading ? (
              <p>Loading...</p>
            ) : (
              <div className="row g-3">
                <div>
                  <h6 className="fw-bold mb-3 position-relative hostel-heading">
                    Hostel
                  </h6>
                </div>
              
                <div className="col-12">
                  <div className="stat-tile text-center big-tile">
                    <p className="label">Total Hostels</p>
                    <h2 className="value">
                      {hostelAndCourse?.data?.totalHostel || 0}
                    </h2>
                  </div>
                </div>

              
                <div className="col-6">
                  <div className="stat-tile text-center">
                    <p className="label">Wardens</p>
                    <h3 className="value">
                      {hostelAndCourse?.data?.totalWarden || 0}
                    </h3>
                  </div>
                </div>

               
                <div className="col-6">
                  <div className="stat-tile text-center">
                    <p className="label">Hostel's Students</p>
                    <h3 className="value">
                      {hostelAndCourse?.data?.totalActiveStudent || 0}
                    </h3>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div> */}
        
      </div>

      {/* GRAPH + SIDE CARD (UNCHANGED) */}
      <div className="row mt-5 g-4">
        {/* GRAPH */}
        <div className="col-lg-8">
          <div className="card-box h-100">
            <div className="d-flex justify-content-between mb-3">
              <h5 className="fw-bold">Visitor Activity</h5>

              <div className="custom-tabs">
                {["week", "month", "year"].map((item) => (
                  <button
                    key={item}
                    className={`tab-btn ${filter === item ? "active" : ""}`}
                    onClick={() => setFilter(item)}
                    data-tooltip={tooltipMap[item] || ""}
                  >
                    {item.charAt(0).toUpperCase() + item.slice(1)}
                  </button>
                ))}
              </div>
            </div>
            <div style={{ height: 300 }}>
              {visitorLoading ? (
                <p>Loading chart...</p>
              ) : (
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={visitorData?.filterBasedData}>
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip content={<CustomTooltip />} />
                    <Bar dataKey="value" fill="#8757e8" />
                  </BarChart>
                </ResponsiveContainer>
              )}
            </div>
          </div>
        </div>

        {/* SIDE CARD */}
        <VisitorOverview data={visitorData} />
      </div>

    </section>
  );
}
